import { FunctionalComponent, h } from "preact";
import { useEffect } from "preact/hooks";

const SetInputUISticky: FunctionalComponent<{
  msgID: string;
  stickyData: any;
  setInputUIStickyCallback: (stickyData: any) => void;
  tickCallback: () => void;
}> = ({ msgID, setInputUIStickyCallback, tickCallback, stickyData }) => {
  useEffect(() => {
    // log.info(`typing for msgID ${msgID}`);
    /** advance queue */
    setInputUIStickyCallback(stickyData);
    tickCallback();
  }, [msgID]);

  return null;
};

export default SetInputUISticky;
